import React from 'react';
import styled from '@emotion/styled';
import { mq } from 'style/variables';
import { EnHeading as EnHeadingBase } from 'components/atoms/enHeading';
import { ShifterProjectsJpDataAcfAbstructContents } from 'types/graphql-types';
import { NonNullableFields } from 'util/types';
import fonts from 'style/fonts';

type ProjectDetailAbstractProps = NonNullableFields<ShifterProjectsJpDataAcfAbstructContents>;

const Container = styled.div<ProjectDetailAbstractProps>``;

const Heading = styled.div`
  margin-bottom: 16px;
`;

const EnHeading = styled(EnHeadingBase)`
  -webkit-text-stroke: 0.2px currentColor;
  text-stroke: 0.2px currentColor;
`;

const Body = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 1.8em;
  font-family: ${fonts.jaGothic};

  ${mq.onlysp} {
    font-size: 17px;
  }
`;

export const ProjectDetailAbstract: React.FC<ProjectDetailAbstractProps> = props => {
  return (
    <Container {...props}>
      {props.heading && (
        <Heading>
          <EnHeading size={'section'}>{props.heading}</EnHeading>
        </Heading>
      )}
      <Body
        dangerouslySetInnerHTML={{
          __html: `${props.text}`,
        }}
      ></Body>
    </Container>
  );
};
